import { isUndefined } from 'lodash';

export default fieldConfig =>
  fieldConfig.path
    .split('.')
    .concat([fieldConfig.valuePath])
    .filter(x => !isUndefined(x));
